import React from 'react';
import { Tabs, styled } from '@mui/material';

import './coe-tabs.component.css';

interface COETabsProps {
  children?: React.ReactNode;
  value: string;
  onChange: (event: React.SyntheticEvent, newValue: string) => void;
  variant?: 'default' | 'segmented';
}

const stripVariant = ({ variant, ...rest }: COETabsProps) => {
  void variant;
  return rest;
};

const DefaultCOETabs = styled((props: COETabsProps) => (
  <Tabs {...stripVariant(props)} style={{ alignItems: 'center' }} TabIndicatorProps={{ style: { display: 'none' } }} />
))({
  '& .MuiButtonBase-root': {
    marginTop: 0,
  },
  '& .MuiTabs-scroller': {
    height: 'auto',
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
});

/** Plain segmented control — avoids MUI Tabs ResizeObserver loops with many tabs. */
const SegmentedTabs: React.FC<COETabsProps> = ({ children, value, onChange }) => {
  return (
    <div className="coe-segmented-tabs" role="tablist">
      {React.Children.map(children, (child) => {
        if (!React.isValidElement<{ value?: string; label?: React.ReactNode }>(child)) return null;
        const tabValue = child.props.value;
        if (tabValue == null) return null;
        const selected = tabValue === value;
        return (
          <button
            key={tabValue}
            type="button"
            role="tab"
            aria-selected={selected}
            className={`coe-segmented-tab${selected ? ' selected' : ''}`}
            onClick={(e) => onChange(e, tabValue)}
          >
            {child.props.label}
          </button>
        );
      })}
    </div>
  );
};

const COETabsComponent: React.FC<COETabsProps> = (props) => {
  if (props.variant === 'segmented') {
    return <SegmentedTabs {...props} />;
  }
  return <DefaultCOETabs {...props} />;
};

export default COETabsComponent;
